




import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component
export default class Slider extends Vue {
  // get some properties
  @Prop({ default: 0 }) min!: number;
  @Prop({ default: 100 }) max!: number;
  @Prop({ default: 0 }) value!: number;

  @Emit()
  change(value: string) {
    return +value;
  }
}
